import React from 'react';

import {
  FormControl,
  RadioGroup,
  RadioGroupProps,
} from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';
//import { DropdownIcon } from '~/components/icons';
import { IConfigurationOption } from '~/domain/IConfigurationOption';
import { IConfigurationOptionInteriorColors } from '~/domain/IConfigurationOptionInteriorColors';
//import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';

import { ConfigurationPackColors } from './ConfigurationPackColors';

interface IConfigurationRadio {
  label: React.ReactNode;
  packs: IConfigurationOptionInteriorColors[];
  onChange: RadioGroupProps['onChange'];
  value: string;
}

interface IInteriors {
  name: string;
  code: string;
}

export const ConfigurationPackSetInteriorColors = React.memo<IConfigurationRadio>(
  function ConfigurationRadio(props) {
    const { packs, onChange, value  } = props;
    
    //sort objects
    let intcolors:IConfigurationOption[] = [];
    intcolors = packs[0].packs.sort((a, b) => (a.name < b.name ? -1 : 1));
    const interiors:IInteriors[] = packs[0].packs;

    return (
      <FormControl
        sx={{
          width: '100%',
          borderBottom: `1px solid ${COLOR_BORDER}`,
          '&:last-of-type': { borderBottom: 0 },
        }}
      >

        <RadioGroup value={value ?? interiors[0].code} onChange={onChange}>
          {intcolors.map((interior,index) => {
            return (
              <ConfigurationPackColors pack={interior} key={interior.code+index} />
            );
          })}
        </RadioGroup>

      </FormControl>
    );
  }
);
